import React from "react";

const IconLock = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 328.9 402">
			<path d="m320.9,190.72c-5.33-5.33-11.8-7.99-19.42-7.99h-9.13v-54.82c0-35.02-12.56-65.09-37.68-90.22C229.54,12.56,199.48,0,164.45,0s-65.1,12.56-90.22,37.69c-25.13,25.13-37.68,55.2-37.68,90.22v54.82h-9.14c-7.61,0-14.08,2.66-19.41,7.99-5.33,5.33-7.99,11.8-7.99,19.42v164.45c0,7.61,2.67,14.09,7.99,19.42,5.33,5.33,11.8,7.99,19.41,7.99h274.08c7.62,0,14.08-2.66,19.42-7.99,5.33-5.33,7.99-11.81,7.99-19.42v-164.46c0-7.61-2.67-14.08-8-19.41Zm-83.36-7.99H91.36v-54.82c0-20.18,7.14-37.4,21.41-51.68,14.28-14.28,31.5-21.41,51.68-21.41s37.4,7.13,51.68,21.41c14.27,14.27,21.41,31.5,21.41,51.68v54.82Z" />
		</svg>
	);
};

export default IconLock;
